import React from 'react';

export type LoaderDotsProps = {
  name?: string;
};

export const LoaderDots = ({ name = 'LOADER_DOTS' }: LoaderDotsProps) => (
  <div className="axiom-loader-dots" data-test={name}>
    <div>&bull;</div>
    <div>&bull;</div>
    <div>&bull;</div>
  </div>
);
